import { render, staticRenderFns } from "./ResidenceHubList.vue?vue&type=template&id=6dbc8e76"
import script from "./ResidenceHubList.vue?vue&type=script&lang=js"
export * from "./ResidenceHubList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports